import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import { hachureLinesForPolygon, hachureLinesForEllipse } from './filler-utils';
export var HachureFiller =
/*#__PURE__*/
function () {
  function HachureFiller(renderer) {
    _classCallCheck(this, HachureFiller);

    this.renderer = renderer;
  }

  _createClass(HachureFiller, [{
    key: "fillPolygon",
    value: function fillPolygon(points, o) {
      return this._fillPolygon(points, o);
    }
  }, {
    key: "fillEllipse",
    value: function fillEllipse(cx, cy, width, height, o) {
      return this._fillEllipse(cx, cy, width, height, o);
    }
  }, {
    key: "_fillPolygon",
    value: function _fillPolygon(points, o) {
      var connectEnds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var lines = hachureLinesForPolygon(points, o);
      var ops = this.renderLines(lines, o, connectEnds);
      return {
        type: 'fillSketch',
        ops: ops
      };
    }
  }, {
    key: "_fillEllipse",
    value: function _fillEllipse(cx, cy, width, height, o) {
      var connectEnds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var lines = hachureLinesForEllipse(cx, cy, width, height, o, this.renderer);
      var ops = this.renderLines(lines, o, connectEnds);
      return {
        type: 'fillSketch',
        ops: ops
      };
    }
  }, {
    key: "renderLines",
    value: function renderLines(lines, o, connectEnds) {
      var ops = [];
      var prevPoint = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var line = _step.value;
          ops = ops.concat(this.renderer.doubleLine(line[0][0], line[0][1], line[1][0], line[1][1], o));

          if (connectEnds && prevPoint) {
            ops = ops.concat(this.renderer.doubleLine(prevPoint[0], prevPoint[1], line[0][0], line[0][1], o));
          }

          prevPoint = line[1];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ops;
    }
  }]);

  return HachureFiller;
}();